<template>
    <b-nav :class="classList">
      <vue-perfect-scrollbar
        class="sidebar-nav-scroll"
        :settings="psSettings"
        v-if="!isTrainingHidden && isTrainingOpen"
      >
        <div class="coursebook-sidebar-buttons ml-4 mr-3 my-2">
          <b-button @click="openDefaultSidebar"
                    class="coursebook-sidebar-buttons__content mt-1"
                    variant="primary">
            Вернуться к меню
          </b-button>
        </div>
        <div class="ml-4 mt-2"> {{trainingName}}</div>
        <div class="coursebook-sidebar-buttons ml-4 mr-3 mt-2">
          <b-button @click="gotoStartPageTraining"
                    class="coursebook-sidebar-buttons__content mt-1"
                    variant="outline-primary">
            Стартовая страница
          </b-button>
          <b-button v-if="hasRole('student')"
            class="coursebook-sidebar-buttons__marks mt-1"
            variant="outline-primary"
            v-b-modal.trainingsMarksModal
          >
            Оценки
          </b-button>
          <trainings-marks-modal />
          <div v-if="$route.params.stepId || $route.path.includes('stages')">
            <div class="mt-2">Роль - {{ selectedRole }}</div>
            <div class="mt-2" v-if="this.selectedGroup">№ команды - {{selectedGroup}}</div>
            <div class="mt-2">Режим - {{(!selectedMode) ? 'Обучение' : 'Самотестирование'}}</div>
            <div class="mt-2">Этап - {{(selectedStep) ? selectedStep.name : ''}}</div>
            <template>
              <sidebar-nav-dropdown
                icon="fas fa-solar-panel"
                label="Пульты">
                <template v-for="(panel, panelIndex) in panels">
                  <div :key="panelIndex"
                    @click="setPanel(panelIndex)">
                    <sidebar-nav-item
                      icon="fas fa-desktop"
                      :key="panelIndex"
                      :label="panel.name"
                    />
                  </div>
                </template>
              </sidebar-nav-dropdown>
            </template>
          </div>
          <div
            v-else-if="$route.path.includes('group-settings') && hasRole(roles_.teacher)"
            class="mt-3"
          >
            <p v-show="students.length > 0">Готовых учеников - {{ students.length }}</p>
            <p v-show="teams.length > 0">Число команд - {{ teams.length }}</p>
            <p v-show="teams.length > 0">Численность в командах:</p>
            <p class="ml-4" v-for="t in teams" :key="t.id">
              Команда {{ t.id }} - {{ t.roles.length }}
            </p>
          </div>
        </div>
        <marks-modal></marks-modal>
      </vue-perfect-scrollbar>
      <vue-perfect-scrollbar
        class="sidebar-nav-scroll"
        :settings="psSettings"
        v-else-if="isGathering && !isGatheringHidden">
        <div class="coursebook-sidebar-buttons ml-4 mr-3 my-2">
          <b-button @click="openDefaultSidebar"
                    class="coursebook-sidebar-buttons__content mt-1"
                    variant="primary">
            Вернуться к меню
          </b-button>
        </div>
        <b-nav>
          <template>
            <sidebar-nav-item
              label="Содержание"
              :url="'/gathering'"
              icon="fas fa-fw fa-lg fa-bars" />
            <sidebar-nav-item
              label="Общее описание"
              :url="'/gathering'"
              icon="far fa-fw fa-lg fa-clone" />
            <sidebar-nav-item
              :label="'1. Линейная часть магистральных газопроводов'"
              :url="'/gathering/main-gas-pipelines'"
              icon="far fa-fw fa-lg fa-clone"
            />
            <sidebar-nav-item
              :label="'2. Разработка и цифровая диагностика компрессорных станций'"
              :url="'/gathering/digital-diagnostics'"
              icon="far fa-fw fa-lg fa-clone"
            />
            <sidebar-nav-item
              :label="'3. Автоматика и системы связи'"
              :url="'/gathering/communication-systems'"
              icon="far fa-fw fa-lg fa-clone"
            />
            <sidebar-nav-item
              :label="'4. Промышленная безопасность'"
              :url="'/gathering/industrial-safety'"
              icon="far fa-fw fa-lg fa-clone"
            />
            <sidebar-nav-item
              :label="'5. Энергоснабжение станций'"
              :url="'/gathering/energy-supply'"
              icon="far fa-fw fa-lg fa-clone"
            />
            <sidebar-nav-item
              :label="'6. Бизнес-информатика и АСУ'"
              :url="'/gathering/business-informatics'"
              icon="far fa-fw fa-lg fa-clone"
            />
            <sidebar-nav-item
              :label="'Анкетирование'"
              :url="'/gathering/poll'"
              icon="far fa-fw fa-lg fa-clone"
            />
          </template>
        </b-nav>
        <marks-modal v-if="hasRole(roles_.student)"></marks-modal>
        <test-role-select-modal />
      </vue-perfect-scrollbar>

      <vue-perfect-scrollbar class="sidebar-nav-scroll" :settings="psSettings"
          v-else-if="!isCourseBookOpen || isCourseBookContentHidden">
        <div class="coursebook-sidebar-buttons ml-4 mr-3 my-2"
          v-if="isCourseBookOpen && isCourseBookContentHidden">
          <b-button @click="openCourseBookSidebar"
            class="coursebook-sidebar-buttons__menu"
            variant="primary">
            Вернуться к учебнику
          </b-button>
        </div>
        <div
          class="coursebook-sidebar-buttons ml-4 mr-3 my-2"
          v-if="isTrainingHidden && isTrainingOpen"
        >
          <b-button @click="openTrainingSidebar"
                    class="coursebook-sidebar-buttons__menu"
                    variant="primary">
            Вернуться к тренажеру
          </b-button>
        </div>
        <div
          class="coursebook-sidebar-buttons ml-4 mr-3 my-2"
          v-if="isGathering && isGatheringHidden"
        >
          <b-button @click="openGatheringSidebar"
                    class="coursebook-sidebar-buttons__menu"
                    variant="primary">
            Вернуться к слету
          </b-button>
        </div>
        <b-nav>
          <template v-for="(item, index) in items">
            <!-- Dropdown -->
            <template v-if="item.children">
                <sidebar-nav-dropdown
                  :key="index"
                  :label="item.label"
                  :url="item.url"
                  :icon="item.icon">
                    <template v-for="(childItem, childIndex) in item.children">
                      <sidebar-nav-item
                        :key="childIndex"
                        :label="childItem.label"
                        :url="childItem.url"
                        :icon="childItem.icon"
                      />
                    </template>
                </sidebar-nav-dropdown>
            </template>
            <!-- Single item -->
            <template v-else>
              <sidebar-nav-item
                :key="index"
                :label="item.label"
                :url="item.url"
                :icon="item.icon"/>
            </template>
          </template>
        </b-nav>
        <olympiad-register-block v-if="hasRole(roles_.student)"></olympiad-register-block>
      </vue-perfect-scrollbar>
      <vue-perfect-scrollbar class="sidebar-nav-scroll" :settings="psSettings" v-else>
        <div class="coursebook-sidebar-buttons ml-4 mr-3 mt-2">
          <b-button @click="openDefaultSidebar"
            class="coursebook-sidebar-buttons__content mt-1"
            variant="primary">
            Вернуться к меню
          </b-button>
          <b-button
            v-if="hasRole(roles_.student) && !isTestingMode"
            v-b-modal.marksModal
            class="coursebook-sidebar-buttons__marks mt-1"
            variant="outline-primary">
            Оценки
          </b-button>
        </div>
        <div v-if="!isTestCreation && courseContent && isCourseMemeber && hasRole(roles_.student)"
          class="coursebook-sidebar-progress ml-4 mr-3 mt-2">
          <div>Пройдено</div>
          <b-progress :max="maxProgressValue">
            <b-progress-bar :value="courseBookProgress" :label-html="progressLabel">
            </b-progress-bar>
          </b-progress>
        </div>
        <b-nav v-if="courseContent && !isTestViewMode && !isTestingMode">
          <sidebar-nav-item
            label="Содержание"
            :url="this.$_getCourseRoutePrefix(this.$route.path) + $route.params.courseBookId"
            icon="fas fa-fw fa-lg fa-bars" />
          <template v-for="(item, index) in content.topics">
            <!-- Dropdown -->
            <template v-if="item.title !== 'Тестирование' && !isTestingMode">
              <sidebar-nav-dropdown
                :key="index"
                :label="item.title"
                icon="far fa-fw fa-lg fa-clone">
                <template v-for="(childItem, childIndex) in item.sections">
                  <sidebar-nav-item
                    :key="childIndex"
                    :label="childItem.title"
                    :url="getLinkForCourseBookSidebar(childItem, false)"
                    icon="far fa-fw fa-lg fa-clipboard"
                  />
                </template>
              </sidebar-nav-dropdown>
            </template>
            <!-- Single item -->
            <template v-else-if="isTestingShowTab">
              <sidebar-nav-dropdown
                :isTesting="true"
                :isTestOk="true"
                :key="index"
                :label="item.title"
                icon="far fa-fw fa-lg fa-edit"
              >
                <template v-for="(childItem, childIndex) in item.sections">
                  <sidebar-nav-item
                    :key="childIndex"
                    :label="childItem.title"
                    :url="getLinkForCourseBookSidebar(childItem, true)"
                    :icon="(childItem.isActivatedTest)
                      ? 'fas fa-fw fa-lg fa-broadcast-tower'
                      : (!childItem.isCreatedByTeacher
                        ? 'fas fa-fw fa-lg fa-clipboard-list'
                        : 'fas fa-sw fa-lg fa-clipboard-check')"
                    :badge="areSettingsOk(childItem)
                      ? null
                      : {variant: 'danger', text: '!'}"
                  />
                </template>
                <b-nav-item
                  v-if="hasRole(roles_.teacher) || hasRole(roles_.content)"
                  @click="createNewTest">
                  <em class="fas fa-plus ml-2 mr-3"></em>
                  <span class="nav-name"> Новый тест </span>
              </b-nav-item>
              </sidebar-nav-dropdown>
            </template>
          </template>
        </b-nav>
        <b-nav v-else>
          <sidebar-nav-item
            label="Тестирование"
            icon="fas fa-fw fa-lg fa-tasks" />
        </b-nav>
        <marks-modal v-if="hasRole(roles_.student)"></marks-modal>
        <test-role-select-modal />
      </vue-perfect-scrollbar>
    </b-nav>

</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import SidebarNavDropdown from '@/components/ui/sidebar/nav/Dropdown.vue'
import SidebarNavItem from '@/components/ui/sidebar/nav/Item.vue'

import TestAPI from '@/api/test'
import RouteMixin from '@/components/helpers/mixins/route-mixin'
import { roles } from '@/config/roles'

const OlympiadRegisterBlock = () => import('@/components/ui/OlympiadRegisterBlock.vue')
const MarksModal = () => import('@/components/content/education/courses/modals/MarksModal.vue')
const TrainingsMarksModal = () => import('@/components/content/education/training/modals/TrainingsMarksModal.vue')
const TestRoleSelectModal = () => import('@/components/content/education/courses/modals/TestCreatingRoleSelection.vue')


export default {
  name: 'SidebarNav',
  components: {
    SidebarNavItem,
    SidebarNavDropdown,
    OlympiadRegisterBlock,
    MarksModal,
    TestRoleSelectModal,
    TrainingsMarksModal
  },
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    }
  },
  mixins: [RouteMixin],
  data() {
    return {
      roles_: roles,
      maxProgressValue: 100,
      // isCourseBookOpen: false,
      isCourseBookContentHidden: false,
      isGatheringHidden: false,
      areTestsOk: true,
      isTrainingHidden: false
    }
  },
  computed: {
    ...mapGetters({
      hasRole: 'currentUser/hasRole',
      courseContent: 'education/getCourseContent',
      testContent: 'education/getTestContent',
      isTestCreation: 'test/isTestCreationMode',
      isTestViewMode: 'test/isTestViewMode',
      courseBookProgress: 'education/getCourseProgress',
      isCourseMemeber: 'education/getCourseMember',
      isTestingMode: 'test/isTestingMode',
      trainingContent: 'training/getTrainingContent',
      selectedStep: 'training/getTrainingStep',
      selectedGroup: 'training/getTrainingGroup',
      selectedRole: 'training/getTrainingRole',
      selectedMode: 'training/getTrainingMode',
      panels: 'training/getPanels',
      selectedPanel: 'training/getSelectedPanel',
      students: 'educationStudentsManagement/getGroupTrainingStudents',
      trainingTeams: 'educationStudentsManagement/getGroupTrainingTeams'
    }),
    isTestingShowTab() {
      const topics = this.content ? this.content.topics : null
      const testing = topics ? topics.find((t) => t.title === 'Тестирование') : null
      const sections = testing ? testing.sections : []
      return !this.isTestCreation && !this.isTestingMode
        && (sections.length || this.hasRole(this.roles_.teacher)
          || this.hasRole(this.roles_.content))
    },
    isCourseBookOpen() {
      return Boolean(this.$route.path.match(/^\/(education|content\/courses)\/.+$/gm) && !this.$route.path.includes('training'))
    },
    isTrainingOpen() {
      return Boolean(this.$route.path.match(/^\/(education\/training|content\/training)\/.+$/gm))
    },
    isTestLoading() {
      return (this.isTestCreation && !this.isTestViewMode && !this.testContent)
    },
    isGathering() {
      console.log(this.$route.path)
      return false
      //return Boolean(this.$route.path.includes('gathering')) //хак для того, чтобы временно убрать доп.меню для слета
    },
    trainingName() {
      return (this.trainingContent && this.trainingContent.contentObject)
        ? this.trainingContent.contentObject.title : ''
    },
    content() {
      if (this.isTestCreation && !this.isTestViewMode && !this.isTestLoading) {
        return this.testContent
      }
      return this.courseContent
    },
    classList() {
      return [
        'sidebar-nav'
      ]
    },
    progressLabel() {
      const ratio = this.courseBookProgress / this.maxProgressValue
      if (ratio <= 0.07) {
        let nbsps = '&nbsp'
        for (let i = 0; i < ratio; i += 0.02) {
          nbsps += '&nbsp'
        }
        return `<div class="text-dark">${nbsps}${this.courseBookProgress}%</div>`
      }
      return `${this.courseBookProgress}%`
    },
    psSettings() {
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 20,
        wheelPropagation: false
      }
    },
    teams() {
      return this.trainingTeams.filter((t) => t.roles.length > 0 && t.id !== null)
    }
  },
  methods: {
    createUrlForGathering(endpoint = '') {
      console.log()
      return `${this.$route.path}${endpoint}`
    },
    openDefaultSidebar() {
      if (this.isGathering) {
        this.isGatheringHidden = true
      } else if (this.isCourseBookOpen) {
        this.isCourseBookContentHidden = true
      } else {
        this.isTrainingHidden = true
      }
    },
    setPanel(index) {
      if (this.selectedPanel !== index) {
        this.setSelectedPanel(index)
      }
    },
    gotoStartPageTraining() {
      let path = `/education/training/${this.$route.params.trainingId}`
      if (this.$route.path.includes('content')) {
        path = `/content/training/${this.$route.params.trainingId}`
      }
      this.$router.push(path)
    },
    openCourseBookSidebar() {
      this.isCourseBookContentHidden = false
    },
    openTrainingSidebar() {
      this.isTrainingHidden = false
    },
    openGatheringSidebar() {
      this.isGatheringHidden = false
    },
    getLinkForCourseBookSidebar(childItem, isTest) {
      return this.$_getSectionUrl(this.$route.path, this.content, childItem, isTest)
    },
    createNewTest() {
      if (this.hasRole(this.roles_.teacher) && this.hasRole(this.roles_.content)) {
        this.$bvModal.show('selectTestRole')
      } else {
        // отправляем запрос на создание нового теста
        TestAPI.makeNewTest(this.$route.params.courseBookId, this.hasRole(this.roles_.teacher))
          .then((response) => {
            this.fetchCourseContent({ id: this.$route.params.courseBookId }).then(() => {
              // переходим на страницу с созданным тестом
              this.$router.push(`${this.$_getCourseRoutePrefix(this.$route.path)}${
                this.$route.params.courseBookId}/test/${
                response.data.id}`)
            })
          })
      }
    },
    areSettingsOk(testSettings) {
      if ((testSettings.isCreatedByTeacher && this.hasRole(this.roles_.teacher))
        || this.hasRole(this.roles_.content)) {
        return testSettings.isSettingsSet
      }

      return true
    },
    ...mapActions({
      updateTestCreationMode: 'test/updateTestCreationMode',
      fetchContentForNewTest: 'test/fetchContentForNewTest',
      fetchCourseContent: 'education/fetchCourseContent'
    }),
    ...mapMutations({
      setSelectedPanel: 'training/setSelectedPanel'
    })
  }
}
</script>

<style scoped>
.coursebook-sidebar-buttons__menu,
.coursebook-sidebar-buttons__marks,
.coursebook-sidebar-buttons__content {
  width: 100%;
  font-size: 15px;
}
</style>
